import React, { useContext } from 'react';
import Modal from 'react-bootstrap/Modal';
import DatePicker from 'react-datepicker';
import { CurrencyLabel, Picker } from '../../../../common/inputs';
import Utility from "../../../../supply-chain/utils/DateParser";
import UserType from '../../../../supply-chain/hooks/useUserType';
import LoadingSpinner from '../../../../common/loaders/loadingSpinner';
import entityContext from "../../../../../context/entityContext";
import authService from "../../../../../services/authService";

const AssignModal = ({
  show,
  onHide,
  selectedTransactions,
  clientDebtorList,
  selectedClientDebtors,
  revisedDueDate,
  revisedDueDateConstraints = {}, // { [ref_id]: { minDate: 'YYYY-MM-DD', maxDate: 'YYYY-MM-DD' } }
  onChangeClientDebtor,
  onChangeDueDate,
  onSubmit,
  submitting,
  clientDebtorLoading = {}, 
  selProduct,

}) => {

   const { constants } = authService.getCurrentUser();

  // helper to convert 'YYYY-MM-DD' or Date -> Date object or null
  const toDateObj = (v) => {
    if (!v) return null;
    if (v instanceof Date) return v;
    // try parse YYYY-MM-DD (safe)
    const parts = String(v).split('-');
    if (parts.length === 3) {
      const [y, m, d] = parts.map(Number);
      return new Date(y, m - 1, d);
    }
    const ts = Date.parse(v);
    return Number.isNaN(ts) ? null : new Date(ts);
  };

  const { ParseDateDMY } = Utility();

  return (
  <Modal show={show} onHide={onHide} size="xl">
    <Modal.Header closeButton>
      <h5 className="modal-title">Submit for funding</h5>
    </Modal.Header>
    <Modal.Body>
      <div className="row">
        {selectedTransactions.length > 0 ? (
          <div className="table-responsive" style={{ overflow: "visible" }}>
           
            <table className="table">
              <thead className="table-light text-secondary">
                <tr>
                  <th>Inv No.</th>
                  <th>Date</th>
                  <th>Due Date</th>
                  <th>Amount</th>
                  <th>Actual Supplier</th>
                  <th><i className='fa fa-info-circle mr-2'  
                         title={`Select ${
                                  selProduct === constants.PRODUCTS.INVOICE ? "Debtor" : "Supplier"
                               } from the drop-down list to match`}>
                      </i>
                      Mapped { selProduct == constants.PRODUCTS.INVOICE ? 'Debtor' : 'Supplier'} 
                      <span className="text-danger">*</span>
                  </th>
                  <th>{ selProduct == constants.PRODUCTS.INVOICE ? 'Advance Date' : 'Revised Due Date'}</th>
                </tr>
              </thead>
              <tbody>
                {selectedTransactions.map((invoice) => {
                  const constraints = revisedDueDateConstraints[invoice.ref_id] || {};
                  const minDateObj = toDateObj(constraints.minDate);
                  const maxDateObj = toDateObj(constraints.maxDate);
                  
                  return (
                    <tr key={invoice.ref_id}>
                      <td>{invoice.inv_number}</td>
                      <td>{invoice.date ? ParseDateDMY(invoice.date) : null}</td>
                      <td>{invoice.dueDate ? ParseDateDMY(invoice.dueDate) : null}</td>
                      <td><CurrencyLabel value={invoice.amount} /></td>
                      <td>{invoice.supplier}</td>
                      <td>
                        <Picker
                          items={clientDebtorList}
                          selectedItem={selectedClientDebtors[invoice.ref_id] || null}
                          onSelectItem={(opt) => onChangeClientDebtor(invoice.ref_id, opt)}
                          name={`supplier_${invoice.ref_id}`}
                          placeholder="Select supplier..."
                        />
                      </td>
                      <td>
                        <DatePicker
                          name="date"
                          className="form-control input-xs"
                          dateFormat="d/M/y"
                          autoComplete="off"
                          placeholderText="Date"
                          onChange={(date) => onChangeDueDate(invoice.ref_id, date)}
                          selected={revisedDueDate[invoice.ref_id] || maxDateObj}
                          minDate={minDateObj}
                          maxDate={maxDateObj}
                          disabled={!!clientDebtorLoading[invoice.ref_id]}
                        />
                         {clientDebtorLoading[invoice.ref_id] && (
                            <LoadingSpinner  normal={true}/>
                         )}
                      </td>
                    </tr>
                  );
                })}
              </tbody>
            </table>
             
          </div>
        ) : (
          <div className="text-center text-muted py-4">No transactions selected.</div>
        )}
      </div>
    </Modal.Body>
    <Modal.Footer>
<span className='text-danger text-xs mt-2'>* Fifopay will remember this supplier mapping next time when you upload.</span>
      <button className="btn btn-light" onClick={onHide} disabled={submitting}>
        Cancel
      </button>
      <button
        className="btn btn-primary"
        onClick={onSubmit}
        disabled={
          submitting ||
          selectedTransactions.length === 0 ||
          selectedTransactions.some((trans) => !selectedClientDebtors[trans.ref_id]?.value)
        }
        title={
          selectedTransactions.some((trans) => !selectedClientDebtors[trans.ref_id]?.value)
            ? 'Please map a Supplier for all selected invoices'
            : 'Sync selected invoices'
        }
      >
        {submitting ? 'Uploading...Please wait' : 'Upload for funding'}
      </button>
    </Modal.Footer>
  </Modal>
 );
};

export default AssignModal;
